import PropTypes from "prop-types";
import { useAuthDataContext, roles as existentRoles } from "components/auth";

const checkValidRoles = roles =>
  roles.forEach((p, i) => {
    if (!Object.values(existentRoles).includes(p)) {
      console.error(`Permission [${p}] does not exist.`);
    }
  });

const RestrictedRoles = ({ roles = [], fallback = null, children }) => {
  const { user } = useAuthDataContext();

  checkValidRoles(roles);

  return roles.some(p => user && user.roles.includes(p)) ? children : fallback;
};

RestrictedRoles.propTypes = {
  /**
   * Permitir el acceso solamente a estos permisos
   */
  roles: PropTypes.array,
  /**
   * Fallback si el usuario no tiene acceso, por defecto null
   */
  fallback: PropTypes.element,
};

export default RestrictedRoles;
